import { Chart } from 'chart.js';
import Labels from './labels';
import { formatNumber2 } from './formatNumber';

const valueLabelsPlugin = {
  id: 'valueLabels',
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    ctx.save();

    ctx.textAlign = 'center';
    ctx.font = 'bold 14px Arial';

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);

      meta.data.forEach((el, i) => {
        const v = dataset.data[i];
        if (Number(v) === 0) return;
        if (v == null) return;

        const text = `${formatNumber2(v)} €`;

        // Obtener x, y (top) y base (eje)
        let x, y, base;
        if (typeof el.getProps === 'function') {
          const p = el.getProps(['x', 'y', 'base'], true);
          x = p.x; y = p.y; base = p.base;
        } else {
          const m = el._model || el._view;
          if (!m) return;
          x = m.x; y = m.y; base = m.base;
        }

        const barHeight = Math.abs(base - y);
        const minHeightForInside = 18;

        if (barHeight >= minHeightForInside) {
          // Dentro, centrado
          ctx.fillStyle = '#000000ff';
          ctx.textBaseline = 'middle';
          const yCenter = (y + base) / 2;
          ctx.fillText(text, x, yCenter);
        } else {
        // Encima del segmento con caja con borde del color del dataset
        const yAbove = Math.min(y, base) - 6;

        ctx.textBaseline = 'middle';

        const metrics = ctx.measureText(text);
        const paddingX = 6;
        const paddingY = 3;
        const textWidth = metrics.width;
        const textHeight = 12;

        const rectX = x - textWidth / 2 - paddingX;
        const rectY = yAbove - textHeight / 2 - paddingY;
        const rectW = textWidth + paddingX * 2;
        const rectH = textHeight + paddingY * 2;

        const border = Array.isArray(dataset.borderColor)
            ? dataset.borderColor[i]
            : dataset.borderColor;

        ctx.strokeStyle = border || '#000';
        ctx.lineWidth = 1.5;
        ctx.strokeRect(rectX, rectY, rectW, rectH);

        ctx.fillStyle = '#000000';
        ctx.fillText(text, x, yAbove);
        }
      });
    });

    ctx.restore();
  }
};  

const getAmountTasksByPeriod = (ctxId, state) => {
    const ctx = document.getElementById(ctxId);

    if (!ctx) {
        return
    }

    if (state.chartTasksAmount) {
        state.chartTasksAmount.destroy();
    }

    const labels = {
    daily: Labels(state.shiftPeriod).daily,
    monthly: Labels(state.shiftPeriod).monthly,
    quarterly: Labels(state.shiftPeriod).quarterly,
    yearly: Labels(state.shiftPeriod).yearly
    };

    const monthlyIds = Labels(state.shiftPeriod).monthlyIds;
    const monthlyAmounts = monthlyIds.map(id => getIndicatorById(state.indicatorsByMonth, id).amountTask);

    // helpers inline
    const monthIdToQuarterId = (monthId) => {
    const [m, y] = monthId.split('-').map(Number);
    const q = Math.floor((m - 1) / 3) + 1;
    return `Q${q}-${y}`;
    };
    const monthIdToYearId = (monthId) => {
    const [, y] = monthId.split('-').map(Number);
    return String(y);
    };

    const qIds = Labels(state.shiftPeriod).quarterlyIds;
    const yIds = Labels(state.shiftPeriod).yearlyIds;

    const qMap = Object.fromEntries(qIds.map(q => [q, 0]));
    const yMap = Object.fromEntries(yIds.map(y => [y, 0]));

    monthlyIds.forEach((mid, idx) => {
    const v = monthlyAmounts[idx] || 0;
    const q = monthIdToQuarterId(mid);
    const y = monthIdToYearId(mid);
    if (qMap[q] !== undefined) qMap[q] += v;
    if (yMap[y] !== undefined) yMap[y] += v;
    });

    const data = {
    daily: Labels(state.shiftPeriod).dailyIds.map(id => getIndicatorById(state.indicatorsByDay, id).amountTask),
    monthly: monthlyAmounts,
    quarterly: qIds.map(q => qMap[q]),
    yearly: yIds.map(y => yMap[y]),
    };

    const chart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: labels[state.period],
            datasets: [{
                label: 'Importe reparaciones',
                data: data[state.period],
                borderWidth: 1,
                backgroundColor: '#90CAF9',
                borderColor: '#90CAF9'
            }]
        },
        options: {
            scales: {
            yAxes: [{
                ticks: { beginAtZero: true }
            }]
            },
            tooltips: {
                enabled: false
            },
        },
        plugins: [valueLabelsPlugin]
    });

    return chart;
}

const getIndicatorById = (indicators, id) => {
    return indicators.find(indicator => indicator.id === id) || { amountTask: 0 };
}

export default getAmountTasksByPeriod;